import { BookingStep } from '@/utils/constants.js';

// Pure step-routing extracted from BookingModal so the branch logic is unit-testable without mounting the modal.

type BookingStepValue = (typeof BookingStep)[keyof typeof BookingStep];

interface AuthFlowTargetInput {
    user: boolean;
    userAddresses: boolean;
    signUpStarted: boolean;
}

interface ChainContinueDisabledInput {
    isChainSuggestionFetching: boolean;
}

export const resolveAuthFlowTarget = ({
    user,
    userAddresses,
    signUpStarted,
}: AuthFlowTargetInput): BookingStepValue => {
    if (!user && signUpStarted) return BookingStep.VERIFICATION_CODE;
    if (!user) return BookingStep.AUTH_SELECTION;
    // `user` is guaranteed truthy past the guards above.
    if (!userAddresses) return BookingStep.ADDRESS;
    return BookingStep.CONFIRM_APPOINTMENT;
};

// A chain patient backing out of auth lands back on the suggestions screen, not the
// single-appointment timeslot picker.
export const resolveAuthBackTarget = (isChainFlow: boolean): BookingStepValue =>
    isChainFlow ? BookingStep.CHAIN_SUGGESTIONS : BookingStep.TIMESLOT_SELECTION;

export const isChainContinueDisabled = ({ isChainSuggestionFetching }: ChainContinueDisabledInput): boolean =>
    isChainSuggestionFetching;
